import Layout from "layout";
import React from "react";
import OrderDetail from "./OrderDetail";

const OrderDetailPage = () => {
  return (
    <Layout>
      <OrderDetail />
    </Layout>
  );
};

export default OrderDetailPage;
